<div class="product-hw">
  <div class="product-hw-header">
    <span class="product-hw-title">How it works</span>
    <span class="product-hw-description"
      >Instantly find out if you are a lucky winner!</span
    >
  </div>
  <div class="product-hw-steps">
    @for (step of steps; track $index) {
      <div class="product-hw-step">
        <div class="product-hw-step-number">{{ $index + 1 }}</div>
        <img src="/assets/svg-icons/{{ step.icon }}" [alt]="step.label" />
        <div class="product-hw-step-title">{{ step.label }}</div>
      </div>
    }
  </div>
</div>
